import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { View } from 'react-native';
import colors from '~/assets/themes/colors';

interface Props {
  value: number;
}

const Progress = ({ value }: Props) => {
  return (
    <View className="items-center">
      <CircularProgressbar
        value={value}
        circleRatio={0.8}
        strokeWidth={4}
        minValue={0}
        maxValue={1}
        styles={{
          ...buildStyles({
            trailColor: colors.light[100],
            pathColor: colors.secondary[800],
            rotation: 0.6,
          }),
          root: {
            width: 250,
          },
        }}
      />
    </View>
  );
};

export default Progress;
